import { ChevronRight, Home } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const labels: Record<string, string> = {
  equipamentos: "Equipamentos",
  suprimentos: "Suprimentos",
  movimentacoes: "Movimentações",
  colaboradores: "Colaboradores",
  emprestimos: "Empréstimos",
  manutencoes: "Manutenções",
  licencas: "Licenças",
  fornecedores: "Fornecedores",
  compras: "Compras",
  inventarios: "Inventários",
  relatorios: "Relatórios",
  auditoria: "Auditoria",
  usuarios: "Usuários",
  "perfis-permissoes": "Perfis e permissões",
  configuracoes: "Configurações",
  novo: "Novo",
  nova: "Nova",
  editar: "Editar",
  historico: "Histórico",
  transferir: "Transferir",
  baixar: "Baixa patrimonial",
  etiqueta: "Etiqueta",
  importar: "Importar",
  entrada: "Entrada",
  saida: "Saída",
  transferencia: "Transferência",
  estornar: "Estornar",
};

function segmentLabel(segment: string) {
  if (labels[segment]) return labels[segment];
  if (/^[0-9a-f-]{20,}$/i.test(segment)) return "Detalhes";
  return segment;
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  return (
    <nav aria-label="Navegação estrutural" className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Link to="/" className="transition hover:text-foreground" aria-label="Dashboard"><Home className="size-3.5" /></Link>
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        const path = `/${segments.slice(0, index + 1).join("/")}`;
        return (
        <span className="flex min-w-0 items-center gap-1.5" key={`${segment}-${index}`}>
          <ChevronRight className="size-3" />
          {isLast ? (
            <span className="max-w-44 truncate font-medium text-foreground">{segmentLabel(segment)}</span>
          ) : (
            <Link to={path} className="max-w-36 truncate transition hover:text-foreground">{segmentLabel(segment)}</Link>
          )}
        </span>
      );})}
    </nav>
  );
}
